import React from "react";
import { Link } from "react-router-dom";
import PaginaEsito from "./esito/PaginaEsito";

// Pagina di esito in italiano, con lo stesso aspetto delle altre pagine di esito
const Error404 = () => (
   <PaginaEsito titolo="Pagina non trovata" variante="danger">
      <p>Controlla l&apos;indirizzo: la pagina potrebbe essere stata spostata.</p>
      <Link className="btn btn-primary btn-add" to="/dashboard">
         Torna alla home
      </Link>
   </PaginaEsito>
);

export default Error404;
